import { Box, Button, Typography } from "@mui/material"

export function ErrorFallback(): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Typography variant="h4">Ocorreu um erro inesperado</Typography>
      <Typography>Tente recarregar a página. Se o problema persistir, contate o suporte.</Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Recarregar página
      </Button>
    </Box>
  )
}
